import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { UserStateService } from '../services/user-state.service';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard implements CanActivate {
  constructor(
    private userStateService: UserStateService,
    private router: Router
  ) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    // Wait for user info to be initialized
    await this.userStateService.waitForInitialization();
    
    const userInfo = this.userStateService.getCurrentUserInfo();
    
    if (!userInfo || !('username' in userInfo)) {
      this.router.navigate(['/account']);
      return false;
    }

    const groups = userInfo.groups || [];
    const routePath = route.routeConfig?.path;

    // Check role-based access
    if (groups.includes('emplay_consultant')) {
      // Emplay consultants can access everything except customer route
      if (routePath !== 'customer') {
        return true;
      } else {
        this.router.navigate(['/home/emplay']);
        return false;
      }
    } else if (groups.includes('customer_consultant')) {
      // Customer consultants can only access customer route
      if (routePath === 'customer') {
        return true;
      } else {
        this.router.navigate(['/home/customer']);
        return false;
      }
    } else if (groups.includes('solution_manager')) {
      // Solution managers have their own route
      this.router.navigate(['/home/solutions-manager/marketplace']);
      return true;
    } else if (groups.includes('sales_rep')) {
      // Sales reps have their own route
      this.router.navigate(['/home/sales-rep']);
      return true;
    } else {
      // No valid role - redirect to documentation
      this.router.navigate(['/home/settings/documentation']);
      return false;
    }
  }
}
